import React from 'react'
import {
  NoteText,
  Messages1,
  ClipboardTick,
  ProfileCircle,
  Profile2User,
  DocumentText,
  Save2
} from 'iconsax-react'
import { useTheme } from '@mui/material'

import { PinnedTab } from '@SonarCX/slices/pinnedTabs'

import useStyles from './styles'

type TabIconProps = {
  type: PinnedTab['type']
}

const TabIcon: React.FC<TabIconProps> = ({ type }) => {
  const theme = useTheme()

  const Icon = React.useMemo(() => {
    if (type === 'note') {
      return NoteText
    }

    if (type === 'team-chat') {
      return Messages1
    }

    if (type === 'task') {
      return ClipboardTick
    }

    if (type === 'contact') {
      return ProfileCircle
    }

    if (type === 'team-member') {
      return Profile2User
    }

    if (type === 'article') {
      return DocumentText
    }

    return Save2
  }, [type])

  const classes = useStyles()

  return (
    <Icon
      variant='Bulk'
      size={theme.size.sm}
      color='black'
      className={classes.root}
    />
  )
}

export default TabIcon
